<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="contents"><a id="page_v"></a>Contents</h2>
<p class="toc"><a id="preface"></a><a class="nounder" href="#/xhtml/preface#preface"><em>Translators’ Preface</em></a></p>
<p class="toc-chap1"><a id="ch01"></a><a class="nounder" href="#/xhtml/ch01#ch01">1. The Place Name(s)—Strasbourg (2004)</a></p>
<p class="toc-chap1"><a id="ch02"></a><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">2. Discussion Between Jacques Derrida, Philippe Lacoue-Labarthe, and Jean-Luc Nancy (2004)</span></p>
<p class="toc-chap1"><a id="ch03"></a><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3. Opening (2003)</span></p>
<p class="toc-chap2"><a id="ch04"></a><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4. Responsibility—Of the Sense to Come (2002)</span></p>
<p class="toc"><a id="notes"></a><span class="nounder" href="#/xhtml/notes#notes" title="Link target outside of Sample"><em>Notes</em></span><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?50034e72